import shops from 'raw-loader!./shops.txt'
import schools from 'raw-loader!./schools.txt'
import hospitals from 'raw-loader!./hospitals.txt'

export default {
  shops,
  schools,
  hospitals,
}
